import {css, tokens} from '@sail/ui';
import {media} from '@sail/engine';
import {helmTokens} from '@sail/helm';

export const styles = {
  backgroundsStyles: css({
    width: 'fill',
    height: 'fill',
    position: 'absolute',
    top: 'space.0',
    left: 'space.0',
    pointerEvents: 'none',
  }),

  backgroundsUnprocessedStyles: css({
    maskImage: `linear-gradient(to bottom, rgba(0, 0, 0, 0.45) calc(-1 * (20px + 180px)), transparent calc(20px + 180px))`,
    [media.up(tokens.viewport.medium)]: {
      maskImage:
        'linear-gradient(to left, rgba(0, 0, 0, 0.45) -50%, transparent 50%)',
    },
  }),

  trackStyles: css({
    stack: 'x',
    width: 'fill',
    minWidth: 'fill',
    overflowX: 'scroll',
    alignY: 'center',
  }),

  trackUnprocessedStyles: css({
    scrollSnapType: 'x mandatory',
    overscrollBehaviorX: 'contain',
    '-webkit-overflow-scrolling': 'touch',
    scrollbarWidth: 'none',
    '::-webkit-scrollbar': {
      display: 'none',
    },
  }),

  indicatorsStyles: css({
    position: 'absolute',
    left: '50%',
    transform: 'translateX(-50%)',
    bottom: '7px',
  }),

  indicatorListStyles: css({
    padding: 'space.0',
    listStyleType: 'none',
    stack: 'x',
  }),

  indicatorStyles: css({
    display: 'block',
    margin: '0 2px',
    padding: '10px 0',
    width: 'large',
    position: 'relative',
    border: 'none',
    appearance: 'none',
    backgroundColor: 'transparent',
    cursor: 'pointer',
    ':before': {
      content: '" "',
      opacity: '0.3',
      width: 'large',
      height: 'xxsmall',
      backgroundColor: '#fff',
      position: 'absolute',
      top: 'calc(50% - 1px)',
      left: 'space.0',
      transformOrigin: 'left center',
      borderRadius: '1px',
    },
    ':after': {
      content: '" "',
      transform: 'scaleX(0)',
      width: 'large',
      height: 'xxsmall',
      backgroundColor: '#fff',
      position: 'absolute',
      top: 'calc(50% - 1px)',
      left: 'space.0',
      transformOrigin: 'left center',
      borderRadius: '1px',
    },
  }),

  activeIndicatorStyles: css({
    ':before': {
      opacity: 1,
    },
    ':after': {
      transform: 'scaleX(1)',
    },
  }),

  navStyles: css({
    marginTop: 'large',
  }),

  navListStyles: css({
    padding: 'space.0',
    listStyleType: 'none',
    margin: 'space.0',
  }),

  navListUnprocessedStyles: css({
    display: 'grid',
    gridTemplateColumns: '50% 50%',
    justifyContent: 'normal',
    align: 'start',
    gap: '32px 0',

    [media.up(tokens.viewport.mobile)]: {
      gridTemplateColumns: 'repeat(auto-fit,25%)',
      justifyContent: 'center',
      align: 'center',
    },
  }),

  navLogoButtonStyles: css({
    backgroundColor: 'transparent',
    border: 'none',
    appearance: 'none',
    cursor: 'pointer',
    padding: 'space.0',
    width: 'fill',
  }),

  navLogoButtonUnprocessedStyles: css({
    alignItems: 'center',
    justifyContent: 'center',
    '-webkit-tap-highlight-color': 'rgba(0,0,0,0)',
  }),

  navLogoStyles: css.global({
    [media.query('(prefers-reduced-motion: no-preference)')]: {
      '.TestimonialCustomLogo :is(path, circle, rect)': {
        transition: `${helmTokens.transition.hover}`,
        transitionProperty: 'fill, stroke',
      },
    },
  }),
};
